import React from 'react'
// import { Text } from '@/components'
import { Typography } from '@mui/material'
import domtoimage from 'dom-to-image';


function PubSchReceipt({ tx_ref, name, examCode, email, examType, price, noOfCandidates }) {

    const receiptSnapshot = async (id, name) => {
        const image = document.getElementById(id);
        const rcptUrl = new Image();

        rcptUrl.src = await domtoimage.toPng(image, { cacheBust: true });
        let downloadLink = document.createElement('a');
        downloadLink.href = rcptUrl.src;
        downloadLink.download = `${name}.png`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }
    return (
        <div className="card-body " >
            <div id={'receipt'} style={{ backgroundColor: 'white', padding: '10px 10px' }}>
                <Typography fontWeight='bold' fontSize='24px' align='center' className="mx-auto" marginBottom={2} >Registration Request Successful</Typography>

                {/* <h3 className='text-center'>{email}</h3> */}
                <div className="row">
                    {/* <ul className="list-unstyled my-3">
                    <li className="text-muted mt-1" style={{ "margin-top": "5px", "margin-bottom": "3px" }}  ><span className="text-black">Bill No</span> :  <span>{tx_ref}</span></li>
                    <li className="text-muted mt-1 flex" style={{ "margin-bottom": "3px" }}  ><span >Date/Time </span>:     </li>
                </ul>
                <hr /> */}

                    {/* <div className="col-xl-6 my-3" style={{ "margin-top": "5px", "margin-bottom": "5px" }} >
                        <p style={{ fontSize: '18px' }}  >Bill No: <span style={{ fontWeight: 'bold' }}   > {tx_ref } </span></p>
                    </div> */}
                    {/* <div className="col-xl-6">
                    <p className="float-end">{examType}
                    </p>
                </div> */}
                    <hr />

                    <div className="col-xl-6 my-3" style={{ "margin-top": "5px", "margin-bottom": "5px" }} >
                        <p style={{ fontSize: '18px' }}  >Date/Time: <span style={{ fontWeight: 'bold' }}   >
                            {new Date().toDateString()} {" "}|{" "}
                            {new Date().toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}
                        </span></p>
                    </div>
                    {/* <div className="col-xl-6">
                    <p className="float-end">{examType}
                    </p>
                </div> */}
                    <hr />

                    <div className="col-xl-6 my-3" style={{ "margin-top": "5px", "margin-bottom": "5px" }} >
                        <p style={{ fontSize: '18px' }}  >Exam Type: <span style={{ fontWeight: 'bold' }}  >{examType}</span></p>
                    </div>
                    {/* <div className="col-xl-6">
                    <p className="float-end">{examType}
                    </p>
                </div> */}
                    <hr />

                    <div className="col-xl-6" style={{ "margin-top": "5px", "margin-bottom": "5px" }}  >
                        <p style={{ fontSize: '18px',  textTransform: "capitalize", }}  >Name: <span style={{ fontWeight: 'bold' }}  >{name}</span></p>
                    </div>
                    {/* <div className="col-xl-6">
                    <p className="float-end">{name}
                    </p>
                </div> */}
                    <hr />
                </div>
                <div className="row">
                    <div className="col-xl-6 " style={{ "margin-top": "5px", "margin-bottom": "5px" }} >
                        <p style={{ fontSize: '18px' }}  >Exam Code: <span style={{ fontWeight: 'bold' }}  >{examCode}</span></p>
                    </div>

                    <hr />
                </div>
                <div className="row">
                    <div className="col-xl-6" style={{ "margin-top": "5px", "margin-bottom": "5px" }}  >
                        <p style={{ fontSize: '18px' }}  >Candidate(s): <span style={{ fontWeight: 'bold' }}  >{noOfCandidates}</span></p>
                    </div>
                    {/* <div className="col-xl-6">
                    <p className="float-end">{noOfCandidates}
                    </p>
                </div> */}
                    <hr />
                </div>
                <div className="row">
                    <div className="col-xl-6" style={{ "margin-top": "5px", "margin-bottom": "5px" }} >
                        <p style={{ fontSize: '18px' }}  >Email: <span style={{ fontWeight: 'bold' }}  >{email}</span></p>
                    </div>
                    {/* <div className="col-xl-6">
                    <p className="float-end">{email}
                    </p>
                </div> */}
                    <hr style={{ border: "2px solid black" }} />
                </div>
                {/* <div className="row text-black ">

                    <div className="col-xl-12" style={{ "margin-top": "5px", "margin-bottom": "5px" }}  >
                        <p className="float-end fw-bold" style={{ fontSize: '18px' }} >Total: <span style={{ fontWeight: 'bold' }}  >{price }</span> </p>
                    </div>
                    <hr style={{ border: "2px solid black" }} />
                </div> */}


                <div className="text-center" style={{ "margin-top": "80px" }}>
                    <p style={{ fontSize: '14px', marginBottom: '10px', display: 'flex', justifyContent: 'center' }} > © Exam Receipt  </p>

                    {/* <a><u className="text-info">View in browser</u></a> */}
                    <p style={{ fontSize: '14px', display: 'flex', justifyContent: 'center' }} >Copyright © 2022 Sterling Tech. All rights reserved. </p>
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px' }}>
                <button onClick={() => receiptSnapshot('receipt', "payment-rcpt")} >download</button>
            </div>

        </div>
    )
}

export default PubSchReceipt